/**
 * @desc  RegisterDataService class.
 * @ngInject
 */
export default class RegisterDataService {
  /**
   * Constructor of the class.
   *
   * @param {$rootScope} $rootScope
   * @param {$q} $q
   * @param {$log}  $log
   * @param {$http} $http
   */
  constructor($rootScope, $q, $log, $http) {
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.$log = $log;
    this.$http = $http;

    this.registerData = [];

    this.$rootScope.$on('scr.select', () => {
      this.registerData.splice(0, this.registerData.length);
    });
  }

  getAll(options = {}) {
    return this.$http({
      method: 'GET',
      url: `/SCR/personalDataRegister/${this.$rootScope.me.schoolCommonRoomId}/changes`,
      params: {
        limit: options.limit,
        offset: options.offset,
        query: options.query
      },
      ignoreLoadingBar: !options.showLoaderSpinner
    }).then(result => {
      this.registerData = result.data.items;
      return result;
    }, err => this.$q.reject(err));
  }
}
